import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容频道",
    links: [
      { label: "影视资讯", to: "/category/film" },
      { label: "音乐推荐", to: "/category/music" },
      { label: "生活方式", to: "/category/lifestyle" },
      { label: "品牌动态", to: "/category/brand" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "品牌服务", to: "/brand" },
      { label: "关于小蜜桃", to: "/about" },
      { label: "全站搜索", to: "/search" },
    ],
  },
];

const socials = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩" },
  { icon: "ri-music-2-line", label: "网易云音乐" },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200 mt-16">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-plant-line"></i>
              </span>
              <span className="font-brand text-2xl text-primary-600">小蜜桃</span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-sm">
              小蜜桃是一个聚焦影视、音乐、生活方式与品牌服务的综合娱乐媒体平台，
              用轻松的方式，陪你把娱乐资讯看得更有意思。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {socials.map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="w-9 h-9 rounded-full bg-background-50 border border-background-200 flex items-center justify-center text-foreground-600 hover:text-primary-600 hover:border-primary-300 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title} className="md:col-span-3">
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">{col.title}</h4>
              <ul className="flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1">
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">关注</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              内容合作请联系
              <br />
              <span className="text-primary-600">hi@xiaomitao.com</span>
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 小蜜桃 Peach Media · 本站内容为演示数据，仅供展示
          </p>
          <div className="flex items-center gap-5 text-xs text-foreground-500">
            <span className="cursor-pointer hover:text-primary-600 transition-colors">
              用户协议
            </span>
            <span className="cursor-pointer hover:text-primary-600 transition-colors">
              隐私政策
            </span>
            <span className="cursor-pointer hover:text-primary-600 transition-colors">
              联系我们
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}